// extracted by mini-css-extract-plugin
export default {"cardWrapper":"card-module--cardWrapper--69a63"};